import { render, staticRenderFns } from "./Dialog_GiftOfTeachingEquipment.vue?vue&type=template&id=405f84d6&"
import script from "./Dialog_GiftOfTeachingEquipment.vue?vue&type=script&lang=js&"
export * from "./Dialog_GiftOfTeachingEquipment.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_GiftOfTeachingEquipment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports